













































































import HelloWorld from './frontend/components/HelloWorld.vue'
import { Component, Prop, Vue } from 'vue-property-decorator';
import OrderItemMarshaller from "./logic/model/OrderItemMarshaller";
import ApiConnector from "./logic/connector/ApiConnector";
import CategoryRepository from "./logic/repository/CategoryRepository";
import Category from "./logic/model/Category";
import Order from "./logic/model/Order";
import OrderRepository from "./logic/repository/OrderRepository";



@Component({
    components: {
        HelloWorld,
    }
})
export default class App extends Vue {

    notification:string = "";
    snackbar:boolean = false;
    devInfoAccepted:boolean = false;
    isExpanded=false;



    get user() {
        return this.$store.state.user;
    }

    logout() {
        new ApiConnector().logout();
        this.$router.push("login");
    }

    

    mounted() {
        if (new ApiConnector().isTokenExpired() === false) {
          this.$store.dispatch('fetchData');
        }
        let self = this;

        window.Echo.channel('pizza-channel')

            .listen('PizzaOrderedEvent', (pizza:any) => {
                self.snackbar = true;
                self.notification = "Eine neue Bestellung ist eingegangen";
                let orderItem = new OrderItemMarshaller(pizza.order);

                self.$store.commit('addOrderItem',orderItem.toModel());

            })
            .listen('OrderRemovedEvent', (event:any) => {
                self.snackbar = true;
                self.notification = "Eine Bestellung wurde zurückgezogen";
                let orderItem = new OrderItemMarshaller(event.order);
                self.$store.commit('removeOrderItem',orderItem.toModel());


            })
            .listen('OrderUpdatedEvent', (event:any) => {
                self.snackbar = true;
                self.notification = "Eine Bestellung aktualisiert";
                let orderItem = new OrderItemMarshaller(event.order);
                self.$store.commit('updateOrderItem',orderItem.toModel());

            })
            .listen('CartCommittedEvent', (event:any) => {
                self.snackbar = true;
                self.notification = "Der Basar wurde geschlossen";
                self.$store.commit("confirmOrder");
            });
    }

    beforeDestroy() {
        console.log("stop listener");
        window.Echo.channel('pizza-channel')
            .stopListening('PizzaOrderedEvent');
    }
}
